import { useMutation } from "@tanstack/react-query";
import { apiV1Endpoint } from "../../../../api/v1";
import axios from "../../../../utils/axiosInceptor";
import { ApiResponse } from "../../../../types/api-response";

type Payload = {
  note: string;
  moduleId: string;
  type: string;
  link: string;
  module?: string;
};

const createNote = async (data: Payload) => {
  const url = `${apiV1Endpoint}/notes`;
  const response = await axios.post<ApiResponse>(url, data);
  return response.data.result;
};

type UseCreateNoteOptions = {
  onSuccess?: () => void;
  onError?: () => void;
};

export const useCreateNote = (options: UseCreateNoteOptions = {}) => {
  const { onSuccess, onError } = options;

  const { mutateAsync, isSuccess, isPending } = useMutation({
    mutationFn: createNote,
    onSuccess,
    onError,
  });

  return {
    createNote: mutateAsync,
    isSuccess,
    isPending,
  };
};
